import ApplicationRecord from './ApplicationRecord';
import NavItem from './NavItem';

export default class ProductPerformance
  extends ApplicationRecord({
    ID: -1,
    Label: '',
    _embedded: {},
  }) {
  /**
   * Performance file linked to the product
   * @return {NavItem} [description]
   */
  file() {
    return this._getOne('File', NavItem);
  }
}



// WEBPACK FOOTER //
// ./src/models/ProductPerformance.js